import { ShieldCheck, MapPin, Clock, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PROMISES = [
  { Icon: ShieldCheck, title: "Fully Insured", desc: "General liability + bonded crews" },
  { Icon: MapPin, title: "Local & Family-Run", desc: "Proudly serving Hampton Roads, VA" },
  { Icon: Clock, title: "24-Hour Quotes", desc: "Custom estimate within one business day" },
  { Icon: Sparkles, title: "Satisfaction Guaranteed", desc: "We don't leave until you approve" },
];

export const PromiseBar = () => (
  <section className="py-16 lg:py-20 bg-[#080808] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
      {PROMISES.map((p, i) => (
        <Reveal
          key={p.title}
          delay={i * 100}
          className={`flex items-start gap-4 ${i > 0 ? "lg:border-l border-white/5 lg:pl-6" : ""}`}
        >
          <div className="shrink-0 h-12 w-12 rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 flex items-center justify-center">
            <p.Icon size={20} strokeWidth={1.4} className="text-[#D4AF37]" />
          </div>
          <div>
            <h3 className="text-white font-medium text-base lg:text-lg">{p.title}</h3>
            <p className="text-white/55 text-xs lg:text-sm mt-1 leading-snug">{p.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
